class API {

    getStreetViewData() {
        // https://maps.googleapis.com/maps/api/streetview/metadata?size=600x300&location=eiffel%20tower,%20paris,%20france&heading=-45&pitch=42&fov=110&key=YOUR_API_KEY&signature=YOUR_SIGNATURE

        const URL = '';

        //fetch()
    }

}

export default new API();
